import { useMutation, useQueryClient } from '@tanstack/react-query'

import { intentionApi } from '../api/intentionApi'
import { INTENTION_TYPE } from '../models/Intention.enums'
import { getIntentionQueryOptions } from './useIntentionQuery'

export const useIntentionMarkAsSharedMutation = (intentionId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => intentionApi.markIntentionAsShared(intentionId),
    onSuccess: (intention) => {
      queryClient.setQueryData(
        getIntentionQueryOptions(intentionId, undefined, INTENTION_TYPE.INTENTION).queryKey,
        intention,
      )
    },
  })
}
